<div class="pricing-selector pb-2" [formGroup]="form">

    @if (!allowsFamily) {
    <!-- SINGLE LIST WHEN FAMILY NOT ALLOWED -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="m-0">Configuración de Prima por Edades</h5>
        <button type="button" class="btn btn-danger d-flex align-items-center gap-2" (click)="addPricing(false)">
            <i class="feather-plus"></i> <span class="d-none d-sm-inline">Agregar Tarifa</span>
        </button>
    </div>

    <!-- Pricing List -->
    <div formArrayName="pricings">
        @if (pricings.controls.length === 0) {
        <div class="text-center text-muted p-4 bg-light rounded border">
            <i class="feather-info d-block mb-2" style="font-size: 1.5rem;"></i>
            No hay tarifas configuradas. Agrega una tarifa usando el botón superior.
        </div>
        }

        @for (pricing of pricings.controls; track $index) {
        <div [formGroupName]="$index" class="card mb-3 border-left-danger shadow-sm bg-white">
            <div
                class="card-header bg-transparent border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                <h6 class="m-0 text-danger">
                    <span class="material-symbols-outlined me-2"
                        style="font-size: 20px; vertical-align: bottom;">attach_money</span> Tarifa #{{ $index + 1 }}
                </h6>
                <button type="button" class="btn btn-outline-danger border-0 btn-sm p-1"
                    (click)="removePricing($index, false)" ngbTooltip="Quitar Tarifa">
                    <span class="material-symbols-outlined" style="font-size: 20px;">delete</span>
                </button>
            </div>

            <div class="card-body py-3">
                <div class="row gx-3">
                    <!-- Rango de Edades -->
                    <div class="col-md-5">
                        <label class="form-label text-muted small fw-bold mb-1">Rango de Edad</label>
                        <div class="d-flex align-items-start gap-2">
                            <div class="form-floating w-100" style="flex: 1;">
                                <input type="text" mask="0*" class="form-control" formControlName="minAge"
                                    [class.is-invalid]="pricing.get('minAge')?.invalid && pricing.get('minAge')?.touched"
                                    placeholder=" " />
                                <label>Desde (Años)</label>
                                @if (pricing.get('minAge')?.invalid && pricing.get('minAge')?.touched) {
                                <div class="invalid-feedback">Requerido</div>
                                }
                            </div>
                            <div class="form-floating w-100" style="flex: 1;">
                                <input type="text" mask="0*" class="form-control" formControlName="maxAge"
                                    [class.is-invalid]="pricing.get('maxAge')?.invalid && pricing.get('maxAge')?.touched"
                                    placeholder=" " />
                                <label>Hasta (Años)</label>
                                @if (pricing.get('maxAge')?.invalid && pricing.get('maxAge')?.touched) {
                                <div class="invalid-feedback">Requerido</div>
                                }
                            </div>
                        </div>
                    </div>

                    <!-- Sexo -->
                    <div class="col-md-3">
                        <label class="form-label text-muted small fw-bold mb-1">Sexo</label>
                        <ng-select [multiple]="true" formControlName="gender" [closeOnSelect]="false"
                            [searchable]="false" [clearable]="false" placeholder="Seleccione..."
                            [class.is-invalid]="pricing.get('gender')?.invalid && pricing.get('gender')?.touched">
                            <ng-option value="M">Masculino</ng-option>
                            <ng-option value="F">Femenino</ng-option>
                        </ng-select>
                        @if (pricing.get('gender')?.invalid && pricing.get('gender')?.touched) {
                        <div class="text-danger small mt-1">Requerido</div>
                        }
                    </div>

                    <!-- Prima / Premium Amount -->
                    <div class="col-md-4">
                        <label class="form-label text-muted small fw-bold mb-1">Monto Prima</label>
                        <div class="input-group input-group-sm">
                            <span class="input-group-text bg-light"><span class="material-symbols-outlined"
                                    style="font-size: 18px;">attach_money</span></span>
                            <input type="text" mask="separator.2" thousandSeparator=","
                                class="form-control fw-bold text-success text-end" formControlName="premiumAmount"
                                [class.is-invalid]="pricing.get('premiumAmount')?.invalid && pricing.get('premiumAmount')?.touched"
                                placeholder="0.00" />
                            @if (pricing.get('premiumAmount')?.invalid && pricing.get('premiumAmount')?.touched) {
                            <div class="invalid-feedback">Requerido</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
    } @else {
    <!-- TWO LISTS WHEN FAMILY ALLOWED -->
    <div class="row">
        <!-- PARENTS COLUMN -->
        <div class="col-12 col-xl-6">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="m-0">Tarifas Titulares</h5>
                <button type="button" class="btn btn-danger btn-sm d-flex align-items-center gap-2"
                    (click)="addPricing(false)">
                    <i class="feather-plus"></i> <span class="d-none d-sm-inline">Agregar</span>
                </button>
            </div>

            <div formArrayName="pricings">
                @if (pricings.controls.length === 0) {
                <div class="text-center text-muted p-4 bg-light rounded border mb-3">
                    <i class="feather-info d-block mb-2" style="font-size: 1.5rem;"></i>
                    No hay tarifas configuradas para titulares.
                </div>
                }

                @for (pricing of pricings.controls; track $index) {
                <div [formGroupName]="$index" class="card mb-3 border-left-danger shadow-sm bg-white">
                    <div
                        class="card-header bg-transparent border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                        <h6 class="m-0 text-danger">
                            <span class="material-symbols-outlined me-2"
                                style="font-size: 20px; vertical-align: bottom;">attach_money</span> Tarifa Titular #{{
                            $index + 1 }}
                        </h6>
                        <button type="button" class="btn btn-outline-danger border-0 btn-sm p-1"
                            (click)="removePricing($index, false)" ngbTooltip="Quitar Tarifa">
                            <span class="material-symbols-outlined" style="font-size: 20px;">delete</span>
                        </button>
                    </div>

                    <div class="card-body py-3">
                        <div class="row gx-3">
                            <!-- Rango de Edades -->
                            <div class="col-12 mb-3">
                                <label class="form-label text-muted small fw-bold mb-1">Rango de Edad</label>
                                <div class="d-flex align-items-start gap-2">
                                    <div class="form-floating w-100" style="flex: 1;">
                                        <input type="text" mask="0*" class="form-control" formControlName="minAge"
                                            [class.is-invalid]="pricing.get('minAge')?.invalid && pricing.get('minAge')?.touched"
                                            placeholder=" " />
                                        <label>Desde (Años)</label>
                                        @if (pricing.get('minAge')?.invalid && pricing.get('minAge')?.touched) {
                                        <div class="invalid-feedback">Requerido</div>
                                        }
                                    </div>
                                    <div class="form-floating w-100" style="flex: 1;">
                                        <input type="text" mask="0*" class="form-control" formControlName="maxAge"
                                            [class.is-invalid]="pricing.get('maxAge')?.invalid && pricing.get('maxAge')?.touched"
                                            placeholder=" " />
                                        <label>Hasta (Años)</label>
                                        @if (pricing.get('maxAge')?.invalid && pricing.get('maxAge')?.touched) {
                                        <div class="invalid-feedback">Requerido</div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <!-- Sexo -->
                            <div class="col-12">
                                <label class="form-label text-muted small fw-bold mb-1">Sexo</label>
                                <ng-select [multiple]="true" formControlName="gender" [closeOnSelect]="false"
                                    [searchable]="false" [clearable]="false" placeholder="Seleccione..."
                                    [class.is-invalid]="pricing.get('gender')?.invalid && pricing.get('gender')?.touched">
                                    <ng-option value="M">Masculino</ng-option>
                                    <ng-option value="F">Femenino</ng-option>
                                </ng-select>
                                @if (pricing.get('gender')?.invalid && pricing.get('gender')?.touched) {
                                <div class="text-danger small mt-1">Requerido</div>
                                }
                            </div>

                            <!-- Prima -->
                            <div class="col-12 mt-2">
                                <label class="form-label text-muted small fw-bold mb-1">Monto Prima</label>
                                <div class="row g-2" formGroupName="premiums">
                                    @for (currency of currencies; track currency.id) {
                                    <div class="col-12">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text bg-light text-muted small fw-bold"
                                                style="width: 60px;">{{ currency.currency }}</span>
                                            <span class="input-group-text bg-light"><span
                                                    class="material-symbols-outlined"
                                                    style="font-size: 18px;">attach_money</span></span>
                                            <input type="text" mask="separator.2" thousandSeparator=","
                                                class="form-control fw-bold text-success text-end"
                                                [formControlName]="currency.id" placeholder="0.00"
                                                [class.is-invalid]="pricing.get('premiums')?.get(currency.id.toString())?.invalid && pricing.get('premiums')?.get(currency.id.toString())?.touched" />
                                            @if (pricing.get('premiums')?.get(currency.id.toString())?.invalid &&
                                            pricing.get('premiums')?.get(currency.id.toString())?.touched) {
                                            <div class="invalid-feedback">Requerido</div>
                                            }
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>

        <!-- CHILDREN COLUMN -->
        <div class="col-12 col-xl-6">
            <div class="d-flex justify-content-between align-items-center mb-3 mt-4 mt-xl-0 border-xl-0 pt-3 pt-xl-0">
                <h5 class="m-0">Tarifas Dependientes</h5>
                <button type="button" class="btn btn-danger btn-sm d-flex align-items-center gap-2"
                    (click)="addPricing(true)">
                    <i class="feather-plus"></i> <span class="d-none d-sm-inline">Agregar</span>
                </button>
            </div>

            <div formArrayName="childPricings">
                @if (childPricings.controls.length === 0) {
                <div class="text-center text-muted p-4 bg-light rounded border">
                    <i class="feather-info d-block mb-2" style="font-size: 1.5rem;"></i>
                    No hay tarifas configuradas para dependientes.
                </div>
                }

                @for (pricing of childPricings.controls; track $index) {
                <div [formGroupName]="$index" class="card mb-3 border-left-danger shadow-sm bg-white">
                    <div
                        class="card-header bg-transparent border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                        <h6 class="m-0 text-danger">
                            <span class="material-symbols-outlined me-2"
                                style="font-size: 20px; vertical-align: bottom;">attach_money</span> Tarifa Dependiente
                            #{{ $index + 1 }}
                        </h6>
                        <button type="button" class="btn btn-outline-danger border-0 btn-sm p-1"
                            (click)="removePricing($index, true)" ngbTooltip="Quitar Tarifa">
                            <span class="material-symbols-outlined" style="font-size: 20px;">delete</span>
                        </button>
                    </div>

                    <div class="card-body py-3">
                        <div class="row gx-3">
                            <!-- Rango de Edades -->
                            <div class="col-12 mb-3">
                                <label class="form-label text-muted small fw-bold mb-1">Rango de Edad</label>
                                <div class="d-flex align-items-start gap-2">
                                    <div class="form-floating w-100" style="flex: 1;">
                                        <input type="text" mask="0*" class="form-control" formControlName="minAge"
                                            [class.is-invalid]="pricing.get('minAge')?.invalid && pricing.get('minAge')?.touched"
                                            placeholder=" " />
                                        <label>Desde (Años)</label>
                                        @if (pricing.get('minAge')?.invalid && pricing.get('minAge')?.touched) {
                                        <div class="invalid-feedback">Requerido</div>
                                        }
                                    </div>
                                    <div class="form-floating w-100" style="flex: 1;">
                                        <input type="text" mask="0*" class="form-control" formControlName="maxAge"
                                            [class.is-invalid]="pricing.get('maxAge')?.invalid && pricing.get('maxAge')?.touched"
                                            placeholder=" " />
                                        <label>Hasta (Años)</label>
                                        @if (pricing.get('maxAge')?.invalid && pricing.get('maxAge')?.touched) {
                                        <div class="invalid-feedback">Requerido</div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <!-- Sexo -->
                            <div class="col-12">
                                <label class="form-label text-muted small fw-bold mb-1">Sexo</label>
                                <ng-select [multiple]="true" formControlName="gender" [closeOnSelect]="false"
                                    [searchable]="false" [clearable]="false" placeholder="Seleccione..."
                                    [class.is-invalid]="pricing.get('gender')?.invalid && pricing.get('gender')?.touched">
                                    <ng-option value="M">Masculino</ng-option>
                                    <ng-option value="F">Femenino</ng-option>
                                </ng-select>
                                @if (pricing.get('gender')?.invalid && pricing.get('gender')?.touched) {
                                <div class="text-danger small mt-1">Requerido</div>
                                }
                            </div>

                            <!-- Prima -->
                            <div class="col-12 mt-2">
                                <label class="form-label text-muted small fw-bold mb-1">Monto Prima</label>
                                <div class="row g-2" formGroupName="premiums">
                                    @for (currency of currencies; track currency.id) {
                                    <div class="col-12">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text bg-light text-muted small fw-bold"
                                                style="width: 60px;">{{ currency.currency }}</span>
                                            <span class="input-group-text bg-light"><span
                                                    class="material-symbols-outlined"
                                                    style="font-size: 18px;">attach_money</span></span>
                                            <input type="text" mask="separator.2" thousandSeparator=","
                                                class="form-control fw-bold text-success text-end"
                                                [formControlName]="currency.id" placeholder="0.00"
                                                [class.is-invalid]="pricing.get('premiums')?.get(currency.id.toString())?.invalid && pricing.get('premiums')?.get(currency.id.toString())?.touched" />
                                            @if (pricing.get('premiums')?.get(currency.id.toString())?.invalid &&
                                            pricing.get('premiums')?.get(currency.id.toString())?.touched) {
                                            <div class="invalid-feedback">Requerido</div>
                                            }
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    }
</div>